/* eslint-disable no-unsafe-optional-chaining */
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Spin,
  Tabs,
  Upload,
  UploadProps,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import {
  activeSimBatch,
  checkConnectionImportExcelSerial,
  checkConnectionInputListSerial,
  createOrderConnection,
  deleteOrther,
  getConnectionBatchDetail,
  retryConnection,
  uploadConnectionImportExcelSerial,
} from 'src/api/connection';
import BoxWithLabel from 'src/components/BoxWithLabel/BoxWithLabel';
import InputCorrect from 'src/components/connection/InputCorrect';
import InputError from 'src/components/connection/InputError';
import ModalConfirmBatchConnect from 'src/components/connection/ModalConfirmBatchConnect';
import ModalConfirmBatchDelete from 'src/components/connection/ModalConfirmBatchDelete';
import ModalConfirm from 'src/components/modals/ModalComfirm';
import ModalConfirmTerms from 'src/components/connection/ModalConfirmTems';
import { usePermission } from 'src/hooks/usePermission';
import { useAppSelector } from 'src/redux/hook';
import { setConnectionState } from 'src/redux/slice/connectionSlice';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { ConnectionType, EnterpriseActiveTermConfigType } from 'src/shared/enum/connection.enum';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { SimType } from 'src/shared/enum/sim.enum';
import {
  ICheckConnectionInputSerialParamsRequest,
  IOverFlowOrderDetailResponse,
} from 'src/shared/interface/connection';
import { exportExcel, formatDateTime, parseQueryString } from 'src/utils';
import { connectionTypeToString } from 'src/utils/connection';
import { simTypeToText } from 'src/utils/sim.enum';

const BatchConnectionCreate = () => {
  const [form] = useForm();
  const { refresh, order, openTabs, masterData } = useAppSelector((state) => state.global);

  const [detailData, setDetailData] = useState<any>();
  const [radio, setRadio] = useState<number>(1);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenConnectModal, setIsOpenConnectModal] = useState<boolean>(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [isOpenTermsModal, setIsOpenTermsModal] = useState<boolean>(false);
  const [termsData, setTermsData] = useState<string[] | undefined>(undefined);
  const [fileImport, setFileImport] = useState<any>(null);
  const [simType, setSimType] = useState<number>(SimType.PHYSICAL_SIM);
  const [simMode, setSimMode] = useState<string>(
    get(masterData, 'simMode', []).map((item: any) => ({
      label: item.name,
      value: item.code,
    }))?.[0]?.value,
  );
  const [type, setType] = useState<string>(ConnectionType.ENTERPRISE);
  const [linkExcelSuccess, setLinkExcelSuccess] = useState<string>('');
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const { dataSuccess, dataFailed } = useAppSelector((state) => state.connection);
  const [dataSuccessSended, setDataSuccessSended] = useState<IOverFlowOrderDetailResponse[]>([]);
  const navigate = useNavigate();
  const { id } = parseQueryString(location.search);
  const [statusSim, setStatusSim] = useState<string>(OrderStatusEnum.New);
  const [isImportFile, setIsImportFile] = useState<boolean>(false);

  const { hasAnyPermission, PERMISSIONS, hasPermission } = usePermission();

  useEffect(() => {
    const fetchDetailOrder = async () => {
      const res = await getConnectionBatchDetail(id);
      if (res) {
        if (res.methodImport === 'import') {
          setRadio(2);
        }
        setType(res.connectionType);
        setSimType(res.simType);
        setSimMode(res.simMode);
        form.setFieldsValue({ ...res, radio: res.methodImport === 'import' ? 2 : 1 });
        setDetailData(res);
        const listCheckSuccess: any[] = [];
        const listCheckFail: any[] = [];
        res.overFlowOrderDetailResponses?.forEach((item: any) => {
          if (res.statusString !== OrderStatusEnum.New) {
            listCheckSuccess.push(item);
          } else if (item.statusString === OrderStatusEnum.Failed) {
            if (item.id) {
              const errorItem = {
                code: item.errorCode,
                message: item.errorMessage,
                serial: item.serial,
              };
              listCheckFail.push(errorItem);
            } else {
              listCheckFail.push(item);
            }
          } else {
            listCheckSuccess.push(item);
          }
        });
        setDataSuccessSended(listCheckSuccess);
        dispatch(setConnectionState({ dataSuccess: id ? listCheckSuccess : [] }));
        if (res.statusString !== OrderStatusEnum.New) {
          dispatch(setConnectionState({ dataFailed: id ? listCheckFail : [] }));
        }
        dispatch(setGlobalState({ order: res }));
        setStatusSim(res.statusString ? res.statusString.toString() : '');
      }
    };

    if (id) {
      fetchDetailOrder();
    } else {
      dispatch(setGlobalState({ order: undefined }));
      dispatch(setConnectionState({ dataSuccess: [], dataFailed: [] }));
      form.resetFields();
    }
    return () => {
      setStatusSim(OrderStatusEnum.New);
    };
  }, [id, refresh]);

  //Confirm reload data when condition change
  const confirmReloadData = (callbackOk?: any, callbackCancel?: any) => {
    if (dataSuccess.length || dataFailed.length) {
      Modal.confirm({
        title: 'Xác nhận',
        icon: <ExclamationCircleOutlined />,
        content: 'Bạn có muốn xoá dữ liệu và thực hiện lại?',
        okText: 'Tiếp tục',
        cancelText: 'Huỷ',
        onOk: () => {
          setFileImport(null);

          dispatch(
            setConnectionState({
              dataSuccess: [],
              dataFailed: [],
            }),
          );
          typeof callbackOk === 'function' && callbackOk();
        },
        onCancel: () => {
          typeof callbackCancel === 'function' && callbackCancel();
        },
      });
    } else {
      typeof callbackOk === 'function' && callbackOk();
    }
  };

  const merchantInfo: string | null = localStorage.getItem('merchantInfo');

  const handleToggleEdit = () => {
    setStatusSim(OrderStatusEnum.EDIT);
  };

  const handleRemoveItemSuccess = (serial: string) => {
    const newDataSuccess = dataSuccess.filter(
      (item: IOverFlowOrderDetailResponse) => item.serial !== serial,
    );
    dispatch(setConnectionState({ dataSuccess: newDataSuccess }));
  };

  const items = [
    {
      label: `${radio === 1 ? 'Nhập đúng' : 'Import đúng'}`,
      key: '1',
      children: (
        <InputCorrect
          data={dataSuccess}
          onRemoveItemSuccess={handleRemoveItemSuccess}
          type={type}
          simType={simType}
          batchStatus={form.getFieldValue('statusString')}
          orderId={form.getFieldValue('id')}
          isEdit={
            statusSim === OrderStatusEnum.EDIT || (statusSim === OrderStatusEnum.New && !id)
              ? false
              : true
          }
        />
      ),
    },
    {
      label: `${radio === 1 ? 'Nhập sai' : 'Import sai'}`,
      key: '2',
      children: <InputError dataFailed={dataFailed} />,
    },
  ];

  const propsUpload: UploadProps = {
    beforeUpload: (file) => {
      const isExcel =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isExcel) {
        message.error(`Định dạng file không đúng`);
      }
      return isExcel || Upload.LIST_IGNORE;
    },
    onChange: ({ file }) => {
      if (file.status === 'removed') {
        setFileImport(null);
      } else {
        file.status = 'done';
        setFileImport(file);
      }
    },
    customRequest: () => handleImport(),
  };

  const handleImport = async () => {
    if (!isImportFile && dataSuccess.length > 0) {
      setOpenModalConfirm(true);
      setIsImportFile(true);
      return;
    }

    if (radio === 2) {
      if (fileImport) {
        const res = await checkConnectionImportExcelSerial({
          distributorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
          excelFile: fileImport.originFileObj ? fileImport.originFileObj : fileImport,
          orderId: id ? id : undefined,
          simType,
          simMode,
        });
        if (res) {
          dispatch(
            setConnectionState({
              dataSuccess: res.simSuccess ?? [],
              dataFailed: res.simError ?? [],
            }),
          );
        }
        setOpenModalConfirm(false);
      } else {
        message.error('Import không thành công. Vui lòng thử lại!');
      }
    }
  };

  const addKeyEditStatus = (arr: any, status: string) => {
    const newArr = arr.map((item: any) => {
      const { serial, subType, simMode } = item;
      return {
        subType,
        serial,
        editStatus: status,
        merchantId: JSON.parse(merchantInfo as string)?.merchantId,
        simMode,
        phoneNumber: item.sim?.isdn ?? item.eSim?.isdn,
      };
    });

    return newArr;
  };

  const handleUploadExcel = async () => {
    try {
      const respon = await uploadConnectionImportExcelSerial({
        file: fileImport?.originFileObj ? fileImport.originFileObj : fileImport,
      });

      setLinkExcelSuccess(respon);
      return respon;
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreateOrder = async (fileUrl: string) => {
    if (dataSuccess.length === 0) {
      message.error('Vui lòng import số!');
      return;
    }

    setIsLoading(true);
    try {
      let bodyInput;

      if (radio === 1) {
        bodyInput = {
          fromSerial: dataSuccess[0].serial,
          toSerial: dataSuccess[dataSuccess.length - 1].serial,
        };
      }

      const bodyRequest = {
        connectionType: 'Device',
        methodImport: `${radio === 1 ? 'input' : 'import'}`,
        fileName: fileImport?.name,
        countSerial: dataSuccess.length,
        type: 'ActiveLot',
        merchantId: JSON.parse(merchantInfo as string)?.merchantId,
        orderEditStatus: 'Create',
        overFlowOrderDetailRequest: dataSuccess.map((data) => {
          const { serial, kindOfSim, packageType, subType } = data;
          return {
            subType,
            serial,
            kindOfSim,
            packageType,
            phoneNumber: data.sim?.isdn ?? data.eSim?.isdn,
            simMode,
          };
        }),
        CreatedBy: JSON.parse(merchantInfo as string)?.merchantName,
        fileUrl: linkExcelSuccess || fileUrl,
        simType,
        simMode,
        ...bodyInput,
      };

      const response = await createOrderConnection(type, bodyRequest);

      if (response) {
        setIsLoading(false);
        message.success('Bạn đã tạo lô thành công !');
        const newPanes = openTabs.filter((pane) => pane.key !== 'connection/batch/list');

        dispatch(
          setGlobalState({
            activeKeyMenu: 'connection/batch/list' + '?id=' + response?.id,
            refresh: !refresh,
          }),
        );

        if (!newPanes.find((tab) => tab.key === 'connection/batch/list' + '?id=' + response?.id)) {
          dispatch(
            setGlobalState({
              openTabs: [
                ...newPanes,
                {
                  label: 'Xem chi tiết lô đấu nối ' + response?.id,
                  children: '',
                  key: 'connection/batch/list' + '?id=' + response?.id,
                  closable: true,
                },
              ],
            }),
          );
        }
        form.resetFields(['serial', 'countSerialNumber']);

        navigate(`/management/connection/batch/list?id=${response?.id}`);
      } else {
        message.error(response?.errorMessage);
      }
    } catch (error: any) {
      setIsLoading(false);
      message.error(error?.response.data.errorMessage);
    }
  };

  const handleEditOrder = async (fileUrl: string) => {
    if (dataSuccess.length === 0) {
      message.error('Vui lòng import số!');
      return false;
    }

    setIsLoading(true);
    let lastDataSuccess;

    if (dataSuccessSended.length > 0) {
      const dataAdd = addKeyEditStatus(
        dataSuccess.filter((data) => {
          const isAdd = dataSuccessSended.find((dataSuccess: IOverFlowOrderDetailResponse) => {
            return dataSuccess.serial === data.serial;
          });
          return !isAdd;
        }),
        'Add',
      );

      const dataRemove = addKeyEditStatus(
        dataSuccessSended.filter((data: IOverFlowOrderDetailResponse) => {
          const isAdd = dataSuccess.find((dataSuccess) => {
            return dataSuccess.serial === data.serial;
          });
          return !isAdd;
        }),
        'Remove',
      );

      lastDataSuccess = [...dataAdd, ...dataRemove];
    }

    try {
      const bodyRequest = {
        orderEditStatus: 'Edit',
        orderId: id,
        overFlowOrderDetailRequest: lastDataSuccess,
        CreatedBy: JSON.parse(merchantInfo as string)?.merchantName,
        fileUrl: linkExcelSuccess || fileUrl,
        simType,
        fileName: fileImport?.name,
        simMode,
      };

      const response = await createOrderConnection(type, bodyRequest);

      if (response) {
        setIsLoading(false);
        dispatch(setGlobalState({ refresh: !refresh }));
        setStatusSim(OrderStatusEnum.New);
        message.success('Bạn đã lưu thông tin thành công !');
        form.resetFields(['serial', 'countSerialNumber']);
      }
    } catch (error: any) {
      setIsLoading(false);
      message.error(error?.response.data.errorMessage);
    }
  };

  const handleSubmit = async () => {
    let fileUrl;
    if (radio === 2) {
      fileUrl = await handleUploadExcel();
    }
    if (statusSim === OrderStatusEnum.New) {
      handleCreateOrder(fileUrl);
    }
    if (statusSim === OrderStatusEnum.EDIT) {
      handleEditOrder(fileUrl);
    }
  };

  const handleConfirmTerms = (selectedTerms: string[]) => {
    setTermsData(selectedTerms);
    setIsOpenTermsModal(false);
    setIsOpenConnectModal(true);
  };

  const handleCancelTermsModal = () => {
    setIsOpenTermsModal(false);
  };

  const handleAddInput = async (isChangeData = false) => {
    if (!Number(form.getFieldValue('countSerialNumber'))) {
      return;
    }

    if (isImportFile) {
      setOpenModalConfirm(true);
      setIsImportFile(false);
      return;
    }

    const params: ICheckConnectionInputSerialParamsRequest = {
      distributorId: JSON.parse(merchantInfo as string)?.merchantId,
      startSerialNumber: form.getFieldValue('serial'),
      countSerialNumber: Number(form.getFieldValue('countSerialNumber')),
      orderId: id ?? undefined,
      simType: simType || SimType.PHYSICAL_SIM,
      simMode: simMode,
    };

    const res = await checkConnectionInputListSerial(type, params);

    if (res) {
      if (isChangeData) {
        setRadio(1);
        dispatch(
          setConnectionState({
            dataSuccess: res.simSuccess ?? [],
            dataFailed: res.simError ?? [],
          }),
        );
        setOpenModalConfirm(false);
      } else {
        if (isImportFile) {
          dispatch(
            setConnectionState({
              dataSuccess: res.simSuccess ?? [],
              dataFailed: res.simError ?? [],
            }),
          );
        } else {
          //Xử lí duplicate
          const newDataSuccess = [...dataSuccess];
          const newDataFailed = [...dataFailed];
          [...dataSuccess, ...res.simSuccess].forEach((item) => {
            //Trường hợp không trùng bất cứ thằng nào.
            if (!dataSuccess.some((obj) => obj.serial === item.serial)) {
              newDataSuccess.push(item);
            }
          });
          [...dataFailed, ...res.simError].forEach((item) => {
            //Trường hợp không trùng bất cứ thằng nào.
            if (!dataFailed.some((obj) => obj.serial === item.serial)) {
              newDataFailed.push(item);
            }
          });
          dispatch(setConnectionState({ dataSuccess: newDataSuccess }));
          dispatch(setConnectionState({ dataFailed: newDataFailed }));
        }
      }
    } else {
      setOpenModalConfirm(false);
    }
  };

  const handleConnect = async (terms?: string[]) => {
    setIsLoading(true);
    try {
      const response = await activeSimBatch(type, id, terms);
      if (response) {
        message.success('Đấu nối thành công!');
        dispatch(setGlobalState({ refresh: !refresh }));
      }
      setIsLoading(false);
      setIsOpenConnectModal(false);
    } catch (error: any) {
      console.log('🚀 ~ handleConnect ~ error:', error);
      setIsLoading(false);
    }
  };

  const handleRetry = async () => {
    setIsLoading(true);
    try {
      const response = await retryConnection({
        orderId: id,
        updatedBy: JSON.parse(merchantInfo as string)?.merchantName,
      });

      if (response) {
        let isStatusRetry = false;
        if (response.statusString === OrderStatusEnum.Completed) {
          isStatusRetry = true;
        }
        if (isStatusRetry) {
          message.success('Retry đấu nối thành công');
        } else {
          // message.error('Retry đấu nối thất bại');
          dispatch(setGlobalState({ refresh: !refresh }));
        }
        setIsLoading(false);
      }
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await deleteOrther(id);
      if (response) {
        message.success('Xoá thành công!');

        const newPanes = openTabs.filter((pane) => pane.key !== 'connection/batch');
        dispatch(
          setGlobalState({
            activeKeyMenu: 'connection/batch',
          }),
        );
        if (!newPanes.find((tab) => tab.key === 'connection/batch')) {
          dispatch(
            setGlobalState({
              openTabs: [
                ...newPanes,
                {
                  label: 'Đấu nối theo lô',
                  children: '',
                  key: 'connection/batch',
                  closable: true,
                },
              ],
            }),
          );
        }
        navigate(`/management/connection/batch`);
      }
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  const handleTypeChange = (value: string) => {
    confirmReloadData(
      () => {
        setType(value);
        setSimMode(
          get(masterData, 'simMode', []).map((item: any) => ({
            label: item.name,
            value: item.code,
          }))?.[0]?.value,
        );
        form.resetFields(['simMode']);
      },
      () => {
        form.setFieldValue('connectionType', type);
      },
    );
  };

  const onChangeCountSerialNumber = (e: any) => {
    if (e?.target?.value > 1000) {
      message.error('Vượt quá số lượng cho phép!');
      form.setFieldValue('countSerialNumber', null);
    }
  };

  const handleExportTemplate = () => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.download = `mau_import_sim.xlsx`;
    const url = process.env.REACT_APP_API_URL + '/api/Provider/export-excel-template?type=1';
    exportExcel(url)
      .then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      })
      .catch((error) => {
        if (error.status === 403) {
          message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
        }
      });
  };

  return (
    <>
      <Spin spinning={isLoading}>
        <div className='flex flex-col gap-10'>
          <Form
            form={form}
            initialValues={{
              device: 'Doanh nghiệp',
            }}
            className='[&_.ant-form-item-label>label]:font-bold [&_.ant-form-item-label>label]:md:font-normal'
          >
            <div className='flex'>
              <div className='row-button justify-end mb-[1.5rem] flex-wrap gap-y-4'>
                {hasPermission(PERMISSIONS.CONNECTION.BATCH_RETRY) && (
                  <Button
                    onClick={handleRetry}
                    disabled={order?.statusString === OrderStatusEnum.Uncompleted ? false : true}
                  >
                    Retry
                  </Button>
                )}
                {hasAnyPermission(
                  PERMISSIONS.CONNECTION.BATCH_PERSONAL_CONNECT,
                  PERMISSIONS.CONNECTION.BATCH_BUSINESS_CONNECT,
                ) && (
                  <Button
                    type='primary'
                    onClick={() => {
                      // Check if terms modal should be shown
                      if (
                        masterData.activeTermsConfig &&
                        masterData.activeTermsConfig.find(
                          (t: any) => t.name === EnterpriseActiveTermConfigType.ActiveLot,
                        )?.description === 'ON' &&
                        type === ConnectionType.ENTERPRISE
                      ) {
                        setIsOpenTermsModal(true);
                      } else {
                        setTermsData(undefined);
                        setIsOpenConnectModal(true);
                      }
                    }}
                    disabled={
                      order?.statusString === OrderStatusEnum.New ||
                      (statusSim === OrderStatusEnum.PAYMENT_FAIL && order?.statusString)
                        ? false
                        : true
                    }
                  >
                    Đấu nối
                  </Button>
                )}

                {hasPermission(PERMISSIONS.CONNECTION.BATCH_DELETE) && (
                  <Button
                    danger
                    onClick={() => setIsOpenDeleteModal(true)}
                    disabled={statusSim === OrderStatusEnum.New && id ? false : true}
                  >
                    Xóa
                  </Button>
                )}

                {hasAnyPermission(
                  PERMISSIONS.CONNECTION.BATCH_PERSONAL_CREATE,
                  PERMISSIONS.CONNECTION.BATCH_BUSINESS_CREATE,
                  PERMISSIONS.CONNECTION.BATCH_PERSONAL_UPDATE,
                  PERMISSIONS.CONNECTION.BATCH_BUSINESS_UPDATE,
                ) && (
                  <Button
                    onClick={async () => {
                      handleSubmit();
                    }}
                    disabled={
                      statusSim === OrderStatusEnum.EDIT ||
                      (statusSim === OrderStatusEnum.New && !id)
                        ? false
                        : true
                    }
                  >
                    Lưu
                  </Button>
                )}
                <Button
                  disabled={statusSim === OrderStatusEnum.New && id ? false : true}
                  onClick={handleToggleEdit}
                >
                  Sửa
                </Button>
              </div>
            </div>

            <BoxWithLabel title='Thông tin lô'>
              <Row gutter={24}>
                <Col span={24} lg={8}>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    labelCol={{ span: 12 }}
                    name={'id'}
                    label='Mã lô'
                  >
                    {form.getFieldValue('id')}
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    labelCol={{ span: 12 }}
                    label='Loại đấu nối'
                    name='connectionType'
                  >
                    <Select
                      showSearch
                      className='min-w-[150px]'
                      placeholder='Vui lòng chọn'
                      defaultValue={ConnectionType.ENTERPRISE}
                      onChange={handleTypeChange}
                      disabled={!!form.getFieldValue('quantityTotal')}
                      options={[
                        {
                          value: ConnectionType.ENTERPRISE,
                          label: connectionTypeToString(ConnectionType.ENTERPRISE),
                        },
                        {
                          value: ConnectionType.INDIVIDUAL,
                          label: connectionTypeToString(ConnectionType.INDIVIDUAL),
                        },
                      ]}
                    ></Select>
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    labelCol={{ span: 12 }}
                    label='Loại SIM'
                    name='simType'
                  >
                    <Select
                      showSearch
                      className='min-w-[150px]'
                      placeholder='Vui lòng chọn'
                      defaultValue={SimType.PHYSICAL_SIM}
                      onChange={(value) => {
                        confirmReloadData(
                          () => {
                            setSimType(value);
                          },
                          () => {
                            form.setFieldValue('simType', simType);
                          },
                        );
                      }}
                      disabled={!!form.getFieldValue('quantityTotal')}
                      options={[
                        {
                          value: SimType.PHYSICAL_SIM,
                          label: simTypeToText(SimType.PHYSICAL_SIM),
                        },
                        {
                          value: SimType.ESIM,
                          label: simTypeToText(SimType.ESIM),
                        },
                      ]}
                    ></Select>
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    labelCol={{ span: 12 }}
                    label='Hình thức SIM'
                    name='simMode'
                  >
                    <Select
                      showSearch
                      className='min-w-[150px]'
                      placeholder='Vui lòng chọn'
                      defaultValue={
                        get(masterData, 'simMode', [])
                          .map((item: any) => ({
                            label: item.name,
                            value: item.code,
                          }))
                          ?.filter((mode: { value: string }) =>
                            type === ConnectionType.INDIVIDUAL ? mode.value === 'NORMAL' : true,
                          )?.[0]?.value
                      }
                      onChange={(value) => {
                        confirmReloadData(
                          () => {
                            setSimMode(value);
                          },
                          () => {
                            form.setFieldValue('simMode', simMode);
                          },
                        );
                      }}
                      disabled={!!form.getFieldValue('quantityTotal')}
                      options={get(masterData, 'simMode', [])
                        .map((item: any) => ({
                          label: item.name,
                          value: item.code,
                        }))
                        .filter((mode: { value: string }) =>
                          type === ConnectionType.INDIVIDUAL ? mode.value === 'NORMAL' : true,
                        )}
                    ></Select>
                    {/* * Nếu là Đấu nối cá nhân chỉ show SIM thường (Feature 73495) */}
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label='Trạng thái'
                    labelCol={{ span: 12 }}
                    name='status'
                  >
                    {form.getFieldValue('statusString')}
                  </Form.Item>
                </Col>
                <Col span={24} lg={6}>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label='Tổng cộng'
                    labelCol={{ span: 12 }}
                  >
                    {form.getFieldValue('quantityTotal')}
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label='Thành công'
                    labelCol={{ span: 12 }}
                  >
                    {form.getFieldValue('quantitySuccess')}
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label='Thất bại'
                    labelCol={{ span: 12 }}
                  >
                    {form.getFieldValue('quantityFailed')}
                  </Form.Item>
                </Col>
                <Col span={24} lg={10}>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label={<div className='text-wrap'>Người tạo</div>}
                    name='created_by'
                    labelCol={{ span: 12 }}
                  >
                    {form.getFieldValue('createdBy')}
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label={<div className='text-wrap'>Thời gian tạo</div>}
                    name='created_at'
                    labelCol={{ span: 12 }}
                  >
                    {form.getFieldValue('createdAt')
                      ? formatDateTime(form.getFieldValue('createdAt'))
                      : ''}
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label={<div className='text-wrap'>Người cập nhật gần nhất</div>}
                    name='updated_by'
                    labelCol={{ span: 12 }}
                  >
                    {form.getFieldValue('updatedBy')}
                  </Form.Item>
                  <Form.Item
                    className='ant-label-flex-wrap'
                    label={<div className='text-wrap'>Ngày cập nhật gần nhất</div>}
                    name='updated_at'
                    labelCol={{ span: 12 }}
                  >
                    {form.getFieldValue('updatedAt')
                      ? formatDateTime(form.getFieldValue('updatedAt'))
                      : ''}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} className='mb-[1rem]'>
                <Col>
                  <Form.Item className='ant-label-flex-wrap' name='radio'>
                    <Radio.Group
                      onChange={(e: RadioChangeEvent) => {
                        confirmReloadData(
                          () => {
                            setRadio(e.target.value);
                          },
                          () => {
                            form.setFieldValue('radio', radio);
                          },
                        );
                      }}
                      disabled={
                        statusSim === OrderStatusEnum.EDIT ||
                        (statusSim === OrderStatusEnum.New && !id)
                          ? false
                          : true
                      }
                      value={radio}
                      defaultValue={1}
                    >
                      <Radio value={1}>Nhập serial</Radio>
                      <Radio value={2}>Import file</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                {radio === 1 ? (
                  <Col span={24}>
                    <Row gutter={16}>
                      <Col span={24} xl={10} xxl={6}>
                        <Form.Item
                          className='ant-label-flex-wrap'
                          label='Từ số serial'
                          name='serial'
                          rules={[
                            {
                              required: true,
                              message: 'Vui lòng nhập số serial',
                            },
                            {
                              min: 16,
                              message: 'Vui lòng nhập đủ số serial',
                            },
                          ]}
                        >
                          <Input
                            type='number'
                            maxLength={20}
                            disabled={
                              statusSim === OrderStatusEnum.EDIT ||
                              (statusSim === OrderStatusEnum.New && !id)
                                ? false
                                : true
                            }
                            onChange={(e) => {
                              if (e.target.value.length <= 20) {
                                form.setFieldValue('serial', e.target.value);
                              } else {
                                form.setFieldValue('serial', e.target.value.substring(0, 20));
                              }
                              e.preventDefault();
                            }}
                            onKeyDown={(evt) => {
                              if (!evt.ctrlKey && !evt.metaKey) {
                                if (
                                  evt.key === 'e' ||
                                  evt.key === '.' ||
                                  evt.key === '+' ||
                                  evt.key === '-' ||
                                  (!isFinite(Number(evt.key)) && evt.key !== 'Backspace') ||
                                  Number(evt.key) > 9 ||
                                  Number(evt.key) < 0
                                ) {
                                  evt.preventDefault();
                                }
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} xl={10} xxl={6}>
                        <Form.Item
                          className='ant-label-flex-wrap'
                          label='Số lượng'
                          name='countSerialNumber'
                          rules={[
                            { required: true, message: 'Vui lòng nhập số lượng' },
                            { max: 1000, message: 'Vượt quá số lượng cho phép.' },
                          ]}
                        >
                          <Input
                            type={'number'}
                            onKeyDown={(evt) => {
                              if (!evt.ctrlKey && !evt.metaKey) {
                                if (
                                  evt.key === 'e' ||
                                  evt.key === '+' ||
                                  evt.key === '.' ||
                                  evt.key === '-' ||
                                  (!isFinite(Number(evt.key)) && evt.key !== 'Backspace') ||
                                  Number(evt.key) > 9 ||
                                  Number(evt.key) < 0
                                ) {
                                  evt.preventDefault();
                                }
                              }
                            }}
                            maxLength={5}
                            disabled={
                              statusSim === OrderStatusEnum.EDIT ||
                              (statusSim === OrderStatusEnum.New && !id)
                                ? false
                                : true
                            }
                            onChange={(value) => onChangeCountSerialNumber(value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} xl={4} xxl={6}>
                        {hasAnyPermission(
                          PERMISSIONS.CONNECTION.BATCH_PERSONAL_CHECK_SERIALS,
                          PERMISSIONS.CONNECTION.BATCH_BUSINESS_CHECK_SERIALS,
                        ) && (
                          <Button
                            onClick={() => {
                              form
                                .validateFields(['serial', 'countSerialNumber'])
                                .then(() => {
                                  if (radio === 1 && !fileImport) {
                                    handleAddInput();
                                  } else {
                                    setOpenModalConfirm(true);
                                  }
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            }}
                            disabled={
                              statusSim === OrderStatusEnum.EDIT ||
                              (statusSim === OrderStatusEnum.New && !id)
                                ? false
                                : true
                            }
                            type='primary'
                          >
                            Thêm
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <>
                    {detailData?.fileUrl && (
                      <Col>
                        <a href={detailData?.fileUrl} download>
                          <Button
                            className='[&_span]:break-words [&_span]:max-w-[200px] [&_span]:whitespace-pre-wrap [&_span]:md:max-w-none'
                            type='link'
                          >
                            {detailData?.fileName || 'Excel file'}
                          </Button>
                        </a>
                      </Col>
                    )}
                    {hasPermission(PERMISSIONS.CONNECTION.BATCH_IMPORT_EXCEL) && (
                      <Col>
                        <div className={'mb-[1rem]'}>
                          <Upload
                            {...propsUpload}
                            fileList={detailData?.fileUrl ? [] : fileImport ? [fileImport] : []}
                            maxCount={1}
                            accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            disabled={
                              statusSim === OrderStatusEnum.EDIT ||
                              (statusSim === OrderStatusEnum.New && !id)
                                ? false
                                : true
                            }
                            className='[&_.ant-upload-list-item.ant-upload-list-item-done]:flex-wrap [&_.ant-upload-list-item.ant-upload-list-item-done]:h-fit [&_.ant-upload-list-item-name]:whitespace-pre-wrap [&_.ant-upload-list-item-name]:max-w-[200px] md:[&_.ant-upload-list-item-name]:max-w-none [&_.ant-upload-list-item-name]:p-0 md:[&_.ant-upload-list-item-name]:p-2 [&_.ant-upload-list-item-name]:break-words'
                          >
                            <Button
                              disabled={
                                statusSim === OrderStatusEnum.EDIT ||
                                (statusSim === OrderStatusEnum.New && !id)
                                  ? false
                                  : true
                              }
                            >
                              Chọn file
                            </Button>
                          </Upload>
                        </div>
                      </Col>
                    )}
                    {hasPermission(PERMISSIONS.CONNECTION.BATCH_EXPORT_TEMPLATE) && (
                      <Col>
                        <Button onClick={() => handleExportTemplate()}>Export template</Button>
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </BoxWithLabel>
          </Form>
          <BoxWithLabel classNames='mb-10 md:mb-0' title='Danh sách SIM đấu nối'>
            <Tabs type='card' items={items} />
          </BoxWithLabel>
        </div>
        <ModalConfirmBatchDelete
          isOpen={isOpenDeleteModal}
          handleCancel={() => setIsOpenDeleteModal(false)}
          handleDelete={handleDelete}
          isLoading={isLoading}
        />
        <ModalConfirmBatchConnect
          isOpen={isOpenConnectModal}
          handleCancel={() => setIsOpenConnectModal(false)}
          handleConnect={handleConnect}
          dataSuccess={dataSuccess}
          isLoading={isLoading}
          termsData={termsData}
        />
        <ModalConfirmTerms
          isOpen={isOpenTermsModal}
          handleCancel={handleCancelTermsModal}
          onConfirm={handleConfirmTerms}
        />
        <ModalConfirm
          open={openModalConfirm}
          content={
            <div className='pb-0 p-8'>
              <div className='font-black text-3xl mb-4'>Bạn chắc chưa?</div>
              <p>Sau khi thêm sẽ xóa dữ liệu trước đó</p>
              <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
                <Button
                  onClick={() => {
                    // Import serial
                    if (radio === 1) {
                      handleAddInput(true);
                    } else {
                      handleImport();
                    }
                  }}
                  className='h-full w-full'
                >
                  XÁC NHẬN
                </Button>
                <Button
                  className='h-full w-full'
                  onClick={() => {
                    setIsImportFile(!isImportFile);
                    setOpenModalConfirm(false);
                  }}
                >
                  THOÁT
                </Button>
              </div>
            </div>
          }
        />
      </Spin>
    </>
  );
};

export default BatchConnectionCreate;
